<template>
    <div>
        <v-icon small v-if="value" color="success">
            mdi-checkbox-marked-circle
        </v-icon>
        <v-icon small v-if="value == null || !value" color="error">
            mdi-close-circle
        </v-icon>
    </div>
</template>
<script>
export default {
  name: 'onOffItem',
  props: {
    value: Boolean,
  },
};
</script>
